import React, {useState} from "react";
import {FaceRecognition} from "cldffecop-biometric";
import {LoadingIframe} from "./LoadingIframe";
import {TitleCustom} from "../../../components/TitleCustom/TitleCustom";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import "./Biometric.scss";
import Margin from "canvas-core-react/lib/Margin";
import TextBody from "canvas-core-react/lib/TextBody";
import iconPerson from "../../../assets/images/icon-person.svg";
import {LoadingScan} from "../LoadingScan";
import {useAppContext} from "../../../context/AppContext";

export const Biometric = () => {
    const {state: context, changeItem} = useAppContext();
    const {rut, document_number} = context.subjectData;
    const defaultResponse = {extra: {previredToken: ""}};

    /* methods componente*/
    const [loadingBiometric, setLoadingBiometric] = useState(false);
    const [validationSuccess, setValidationSuccess] = useState(false);
    const handleValidationOk = (response = defaultResponse) => {
        changeItem({previredToken: response.extra.previredToken});
        setValidationSuccess(true);
        changeItem({clientStep: "stepProducts"})
    };
    return (
        <div className="Biometric">
            {!loadingBiometric && (
                <React.Fragment>
                    <TitleCustom
                        image={<img src={iconPerson} alt="iconPerson"/>}
                        text="¡Queremos saber si eres tú!"
                    />
                    <Margin id="infoBiometric" lg={18} md={18} xs={18}>
                        <Row className="align-items--center">
                            <Column>
                                <TextBody component="p" type="1">
                                    En los siguientes pasos, vamos a realizar la validación para
                                    comprobar tu identidad y verificar tus datos.
                                </TextBody>
                            </Column>
                        </Row>
                    </Margin>
                </React.Fragment>
            )}
            <Margin id="iframeBiometric" lg={42} md={42} xs={36}>
                <Row
                    justifyContent="center"
                    className="align-items--center"
                    id="Biometric"
                >
                    <Column lg={10} md={10}>
                        <FaceRecognition
                            actionOnError={() => changeItem({validationChoice: null,validationCheck: false})}
                            labelOnError={"Volver"}
                            onValidationOk={() => handleValidationOk()}
                            onProgress={(e) => setLoadingBiometric(e.isLoadingScan)}
                            LoadingIframe={LoadingIframe}
                            LoadingScan={() => (
                                <LoadingScan
                                    validationSuccess={validationSuccess}
                                />
                            )}
                            expectedCustomerId={rut}
                            expectedDocumentNumber={document_number}
                            skipTokenPrevired={true}
                        />
                    </Column>
                </Row>
            </Margin>
        </div>
    );
};